// Rascunho local do despacho (sessionStorage): cópia temporária do que o
// usuário está digitando, para não perder o texto em refresh/fechamento de
// aba. NÃO substitui o "Salvar despacho" (backend) — é por aba, isolado por
// usuário e documento, e removido após salvar/enviar com sucesso.
const PREFIXO = 'RASCUNHO_DESPACHO_'
const MAX_AGE_MS = 12 * 60 * 60 * 1000

function obterStorage () {
  try {
    return window.sessionStorage
  } catch (error) {
    return null
  }
}

function montarChave (idDocumento, idUsuario) {
  return PREFIXO + String(idUsuario) + '_' + String(idDocumento)
}

function listarChaves (store, filtro) {
  const chaves = []
  for (let i = 0; i < store.length; i++) {
    const key = store.key(i)
    if (key && key.indexOf(PREFIXO) === 0 && (!filtro || filtro(key))) chaves.push(key)
  }
  return chaves
}

function salvarRascunho ({ idDocumento, idUsuario, html, texto, tipoDespacho, nivelAcesso, hipoteseLegal, fluxoId, destinoId }) {
  const store = obterStorage()
  if (!store || idDocumento == null || idUsuario == null) return null
  const registro = {
    html: html || '',
    texto: texto || '',
    tipoDespacho: tipoDespacho || null,
    nivelAcesso: nivelAcesso || null,
    hipoteseLegal: hipoteseLegal != null ? hipoteseLegal : null,
    fluxoId: fluxoId != null ? fluxoId : null,
    destinoId: destinoId != null ? destinoId : null,
    timestamp: Date.now()
  }
  try {
    store.setItem(montarChave(idDocumento, idUsuario), JSON.stringify(registro))
    return registro
  } catch (error) {
    // rascunho é best-effort: quota/indisponibilidade não devem quebrar a tela
    return null
  }
}

function obterRascunho ({ idDocumento, idUsuario }) {
  const store = obterStorage()
  if (!store || idDocumento == null || idUsuario == null) return null
  try {
    const dados = JSON.parse(store.getItem(montarChave(idDocumento, idUsuario)))
    if (!dados || typeof dados.html !== 'string') return null
    if (typeof dados.timestamp !== 'number' || Date.now() - dados.timestamp > MAX_AGE_MS) {
      removerRascunho({ idDocumento })
      return null
    }
    return dados
  } catch (error) {
    return null
  }
}

function removerRascunho ({ idDocumento }) {
  const store = obterStorage()
  if (!store || idDocumento == null) return
  const sufixo = '_' + String(idDocumento)
  listarChaves(store, (key) => key.slice(-sufixo.length) === sufixo).forEach((key) => {
    store.removeItem(key)
  })
}

function removerRascunhos () {
  const store = obterStorage()
  if (!store) return
  listarChaves(store).forEach((key) => {
    store.removeItem(key)
  })
}

export { salvarRascunho, obterRascunho, removerRascunho, removerRascunhos }
export default { salvarRascunho, obterRascunho, removerRascunho, removerRascunhos }
